import 'core-js'
import 'regenerator-runtime/runtime'

const renderHead = ( html, modname ) => {
  const $container = $(`<div class="mainImg"><div class="mainImgInner">${ html }</div></div>`)
  $('.moduletitle').remove()
  let needle = ''
  switch( modname ){
    case 'privacy': needle = $.UA.is_mobile ? '.ui-content[role="main"]' : '#allbox .breadcrumbs'; break
    case 'sitemap': needle = $.UA.is_mobile ? '.element_list.sitemap' : '#allbox .breadcrumbs'; break
    case 'profile': needle = $.UA.is_mobile ? '.ui-content[role="main"]' : '#allbox .breadcrumbs'; break
    default : needle = $.UA.is_mobile ? '#hybsMob > .contentsImg': ''; break
  }
  if( needle ) $( needle ).before( $container )
  window.load['CONTENT_HEADER'].resolve()
}

const init = async (opt) => {
  const optionPageHeader = Object.assign({
    'privacy': '<h2><span>Privacy Policy</span></h2>',
    'sitemap': '<h2><span>Sitemap</span></h2>',
    'profile': '<h2><span>Profile</span></h2>',
  }, opt)
  const getContentHeader = $.get('/hs_data/design_item_topfree.xml')
  const getModuleinfo = $.get('/hs_data/module_info.xml')
  const thisCont = location.pathname.replace(/^\/([^/]+)(\/|\.php)(.+)?$/,'$1')
  const thisModname = $( await getModuleinfo ).find(`MODULE_TITLE:contains(${ thisCont })`).siblings('MODULE')[0].textContent
  const thisContHead = $( await getContentHeader ).find(`REC_NO#${thisModname}_head BODY`)

  if( /(privacy|sitemap|profile)/.test( thisModname ) ){
    renderHead( optionPageHeader[ thisModname ], thisModname )
  }else if ( thisContHead.length > 0 ){
    renderHead( thisContHead.text(), thisModname )
  }

}

export default function CONTENT_HEADER (opt) {
  window.load['CONTENT_HEADER'] = window.load['CONTENT_HEADER'] || new $.Deferred
  document.addEventListener('DOMContentLoaded', init(opt) )
}